export default "__VITE_ASSET__GHwJhsrM__"